import { render, staticRenderFns } from "./Table.vue?vue&type=template&id=f225c340&scoped=true&"
import script from "./Table.vue?vue&type=script&lang=js&"
export * from "./Table.vue?vue&type=script&lang=js&"
import style0 from "./Table.vue?vue&type=style&index=0&id=f225c340&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f225c340",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f225c340')) {
      api.createRecord('f225c340', component.options)
    } else {
      api.reload('f225c340', component.options)
    }
    module.hot.accept("./Table.vue?vue&type=template&id=f225c340&scoped=true&", function () {
      api.rerender('f225c340', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Email/GlobalFilters/Table.vue"
export default component.exports